<template>
  <div>
    <div v-if="widthMax > 768" class="columns" id="activityNav">
      <div v-if="getRule !== 'exclusiveboard'" class="column">
        <router-link
          to="/dashboard/activities"
          class="button is-large btnNavNotActive"
          :class="{ btnNavActive: nav.dashboard }"
        >
          <span class="icon is-medium">
            <i
              class="fas fa-chart-line navColorNotActive"
              :class="{ navColorActive: nav.dashboard }"
            ></i>
          </span>
          <span
            class="navColorNotActive"
            :class="{ navColorActive: nav.dashboard }"
            >{{ $t("menu.dashboard") }}</span
          >
        </router-link>
      </div>
      <div v-if="getRule !== 'exclusiveboard'" class="column">
        <router-link
          to="/activity"
          class="button is-large btnNavNotActive"
          :class="{ btnNavActive: nav.activity }"
        >
          <span class="icon is-medium">
            <i
              class="fas fa-list-ul navColorNotActive"
              :class="{ navColorActive: nav.activity }"
            ></i>
          </span>
          <span
            class="navColorNotActive"
            :class="{ navColorActive: nav.activity }"
            >{{ $t("menu.activity") }}</span
          >
        </router-link>
      </div>
      <div class="column">
        <router-link
          to="/milestone"
          class="button is-large btnNavNotActive"
          :class="{ btnNavActive: nav.milestone }"
        >
          <span class="icon is-medium">
            <i
              class="fas fa-signal navColorNotActive"
              :class="{ navColorActive: nav.milestone }"
            ></i>
          </span>
          <span
            class="navColorNotActive"
            :class="{ navColorActive: nav.milestone }"
            >{{ $t("menu.mileStone") }}</span
          >
        </router-link>
      </div>
      <div class="column">
        <router-link
          to="/document-activities"
          class="button is-large btnNavNotActive"
          :class="{ btnNavActive: nav.document }"
        >
          <span class="icon is-medium">
            <i
              class="fa fa-folder-open navColorNotActive"
              :class="{ navColorActive: nav.document }"
            ></i>
          </span>
          <span
            class="navColorNotActive"
            :class="{ navColorActive: nav.document }"
            >{{ $t("menu.document") }}</span
          >
        </router-link>
      </div>
    </div>
    <div v-else class="scrollNav" style="background-color: #00a79d">
      <swiper :options="swiperOptionMobile">
        <swiper-slide v-if="getRule !== 'exclusiveboard'" class="text-center">
          <div
            @click="activeNav('/dashboard/activities')"
            class="flex-1 nav-mobile-activity"
            :style="{ borderColor: nav.dashboard ? '#fff' : '#00a79d' }"
          >
            <p
              class="has-text-centered has-text-white has-text-weight-normal is-size-6"
            >
              {{ $t("menu.dashboard") }}
            </p>
          </div>
        </swiper-slide>
        <swiper-slide v-if="getRule !== 'exclusiveboard'" class="text-center">
          <div
            @click="activeNav('/activity')"
            class="flex-1 nav-mobile-activity"
            :style="{ borderColor: nav.activity ? '#fff' : '#00a79d' }"
          >
            <p
              class="has-text-centered has-text-white has-text-weight-normal is-size-6"
            >
              {{ $t("menu.activity") }}
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="text-center">
          <div
            @click="activeNav('/milestone')"
            class="flex-1 nav-mobile-activity"
            :style="{ borderColor: nav.milestone ? '#fff' : '#00a79d' }"
          >
            <p
              class="has-text-centered has-text-white has-text-weight-normal is-size-6"
            >
              {{ $t("menu.mileStone") }}
            </p>
          </div>
        </swiper-slide>
        <swiper-slide class="text-center">
          <div
            @click="activeNav('/document-activities')"
            class="flex-1 nav-mobile-activity"
            :style="{ borderColor: nav.document ? '#fff' : '#00a79d' }"
          >
            <p
              class="has-text-centered has-text-white has-text-weight-normal is-size-6"
            >
              {{ $t("menu.document") }}
            </p>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

/* eslint-disable */
<style scoped>
.scrollNav::-webkit-scrollbar {
  width: 1em;
}

.scrollNav::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.3);
}

.scrollNav::-webkit-scrollbar-thumb {
  background-color: transparent;
  outline: 1px solid slategrey;
}
.navColorActive {
  color: #fff !important;
}
.btnNavActive {
  background-color: #6d8df3 !important;
  width: 100%;
}
.navColorNotActive {
  color: #d8d8d8;
}
.btnNavNotActive {
  background-color: #fff;
  width: 100%;
}
#activityNav {
  min-height: 78px;
  display: -webkit-box !important;
  padding: 0 10px;
}
@media only screen and (max-width: 768px) {
  #activityNav {
    min-height: 78px;
    display: unset !important;
  }
}
.nav-mobile-activity {
  border-bottom-width: 3px;
  border-bottom-style: solid;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 15px;
  padding-top: 15px;
  cursor: pointer;
}
#navMobileActivity {
  margin-top: -15px;
}
</style>

<script>
// @ is an alias to /src

export default {
  props: {
    nav: Object,
  },
  computed: {
    getRule() {
      return this.$store.state.rule;
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      swiperOptionMobile: {
        speed: 1000,
        autoplay: false,
        slidesPerView: 3,
        // scrollbar: {
        //   el: '.swiper-scrollbar',
        //   hide: false
        // }
      },
    };
  },
  methods: {
    activeNav(link) {
      this.$router.push(link);
    },
  },
};
</script>
